import { WrappedSalaryEstimationSection } from './WrappedSalaryEstimation';

export default WrappedSalaryEstimationSection;
